// this is done so that material ui plays nice with StrictMode
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';

/**
 * @deprecated
 * Use default export from `'@/theme'` instead.
 */
export const oldTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#ff1744',
    },
    background: {
      default: '#fff',
    },
  },
  typography: {
    fontFamily: [
      'Proxima Nova',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    info: {
      main: '#F1F9FF',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#ff1744',
    },
    background: {
      default: '#fff',
      paper: '#fafafa',
    },
    grey: {
      100: '#FFFFFF',
      300: '#F7F6F5',
      500: '#989BA4',
      700: '#6A717D',
      800: '#363334',
      900: '#000008',
    },
  },
  typography: {
    fontFamily: [
      'GT Walsheim',
      'Proxima Nova',
    ].join(','),
    button: {
      textTransform: 'none',
    },
    h1: {
      fontSize: 28,
      lineHeight: '36px',
      fontWeight: 700,
    },
    h2: {
      fontSize: 24,
      lineHeight: '32px',
      fontWeight: 700,
    },
    h3: {
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 700,
    },
    body1: {
      fontSize: 18,
      lineHeight: '26px',
      fontWeight: 400,
    },
    body2: {
      fontSize: 18,
      lineHeight: '26px',
      fontWeight: 700,
    },
    subtitle2: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
    },
    caption: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
    },
  },
  props: {
    MuiTypography: {
      color: 'textPrimary',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        boxShadow: 'none',
        borderRadius: 8,
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '32px',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 8,
      },
    },
    MuiFormLabel: {
      root: {
        fontWeight: 500,
      },
    },
    MuiPopover: {
      root: {
        family: 'GT Walsheim',
      },
    },
  },
});

export default theme;
